import { Trans } from 'react-i18next';

// Import hooks
import { useConfiguratorContext } from 'components/context/configurator/ConfiguratorProvider';
import { usePriceInfo } from './hooks/usePriceInfo';

// Import styles
import { Price, PricePeriod, CurrentPrice, PriceDisclaimer, PriceContainer } from './styles';

// Import types
import { CalculatedPriceProduct } from 'types/api/packetsSubscription';

// Import components
import { Skeleton } from 'components/views/offer_configurator/components/common';

type Modifiers = 'main' | 'premium' | 'summary' | 'group' | 'table';

type Props = {
	calculatedPrice?: CalculatedPriceProduct;
	width?: number;
	modifiers?: Modifiers | Modifiers[];
	isGroup?: boolean;
};

const PriceInfo = ({ calculatedPrice, width = 100, modifiers = 'main', isGroup = false }: Props) => {
	const { settings } = useConfiguratorContext();
	const { isPromotion, standardPrice, currentPrice, promotionDuration } = usePriceInfo(calculatedPrice);

	return (
		<PriceContainer width={width} modifiers={modifiers} isPromotion={isPromotion}>
			<Skeleton isLoading={!calculatedPrice} count={3}>
				{isPromotion && (
					<CurrentPrice>
						<Trans ns="configurator" i18nKey="price" values={{ price: standardPrice }} />
					</CurrentPrice>
				)}

				<Price isPromotion={isPromotion}>
					<Trans
						ns="configurator"
						i18nKey={isGroup ? 'from_price_with_duration' : 'price_with_duration'}
						values={{
							price: currentPrice,
							duration: settings?.billing_duration.period
						}}
						components={{ span: <PricePeriod /> }}
					/>
				</Price>

				{isPromotion && (
					<PriceDisclaimer>
						<Trans ns="configurator" i18nKey="price_promotion_duration_span" count={promotionDuration} values={{ price: standardPrice }} />
					</PriceDisclaimer>
				)}
			</Skeleton>
		</PriceContainer>
	);
};

export default PriceInfo;
